const COMMON_WORDS = new Set([
	'a', 'ad', 'am', 'an', 'applicable', 'approval', 'approve', 'are', 'as', 'at', 'ate', 'autotask',
	'away', 'back', 'bathroom', 'billing', 'bios', 'bit', 'break', 'busy', 'call', 'calling',
	'client', 'clients', 'computer', 'connectwise', 'customer', 'datto', 'desk', 'dhcp', 'did',
	'dispatch', 'dns', 'do', 'doing', 'done', 'eat', 'eating', 'email', 'emails', 'event', 'fd',
	'fixing', 'fixed', 'food', 'for', 'freshdesk', 'freshservice', 'from', 'gmail', 'got', 'gpo',
	'had', 'have', 'hdd', 'help', 'helpdesk', 'helped', 'helping', 'i', 'idle', 'in', 'is', 'isp',
	'issue', 'issues', 'it', 'jira', 'just', 'kaseya', 'labor', 'lan', 'little', 'long', 'lunch',
	'manager', 'me', 'meeting', 'mfa', 'minute', 'minutes', 'my', 'ninja', 'not', 'nothing', 'note',
	'notes', 'nvme', 'on', 'ou', 'outlook', 'override', 'parts', 'phone', 'poe', 'pos', 'problem',
	'problems', 'quick', 'rdp', 'reading', 'really', 'refusal', 'refused', 'restroom', 'servicenow',
	'short', 'slack', 'someone', 'something', 'spoke', 'ssd', 'ssh', 'sso', 'supervisor', 'syncro',
	'system', 'systems', 'talk', 'talking', 'taking', 'team', 'teams', 'tech', 'the', 'ticket',
	'tickets', 'to', 'took', 'training', 'uefi', 'very', 'viewer', 'vlan', 'vpn', 'wait', 'waiting',
	'waive', 'waived', 'waiving', 'wan', 'warranty', 'was', 'we', 'were', 'wifi', 'with', 'wlan',
	'work', 'worked', 'working', 'zendesk', 'zoom',
]);

const WORKFLOW_WORDS = new Set([
	'admin', 'antivirus', 'av', 'bypass', 'bypassing', 'cbs', 'chkdsk', 'cleanupimage',
	'cmd', 'command', 'commands', 'company', 'dism', 'disms', 'four', 'health', 'inspection',
	'inspections', 'machine', 'malwarebytes', 'point', 'powershell', 'reboot', 'rebooted',
	'removal', 'restore', 'restorehealth', 'rights', 'scan', 'scanhealth', 'sfc', 'sfcs',
	'software', 'tests', 'viewers', 'virus', 'visit',
]);

const ALLOWED_WORDS = new Set([...COMMON_WORDS, ...WORKFLOW_WORDS]);

const MAX_GIBBERISH_RATIO = 0.2;

function hasConsonantCluster(word, minLength = 6) {
	return new RegExp(`[bcdfghjklmnpqrstvwxyz]{${minLength},}`, 'i').test(word);
}

function isGibberishWord(word) {
	const lower = word.toLowerCase();
	if (ALLOWED_WORDS.has(lower)) {
		return false;
	}
	if (lower.length > 24) {
		return true;
	}
	if (hasConsonantCluster(lower)) {
		return true;
	}
	if (lower.length >= 4 && !/[aeiou]/i.test(lower)) {
		return true;
	}
	return false;
}

/**
 * Validates AFK modal reasoning text. Returns an error message or null if valid.
 * @param {string} reasoning
 * @returns {string|null}
 */
export function validateReasoning(reasoning) {

	const trimmed = (reasoning || '').trim();
	if (trimmed.length < 15) {
		return 'Please write at least a short sentence.';
	}

	const words = trimmed.match(/[a-zA-Z]{2,}/g) || [];
	if (words.length < 2) {
		return 'Please use real words explaining what you were doing.';
	}

	const letters = trimmed.replace(/[^a-zA-Z]/g, '');
	if (letters.length < 4) {
		return 'Please use real words explaining what you were doing.';
	}

	const counts = {};
	for (const ch of letters.toLowerCase()) {
		counts[ch] = (counts[ch] || 0) + 1;
	}

	const maxCount = Math.max(...Object.values(counts));
	if (maxCount / letters.length > 0.4) {
		return "That doesn't look like a real explanation. Please write a brief sentence.";
	}

	const tokens = trimmed.split(/\s+/).filter(Boolean);
	if (tokens.length >= 5) {
		const singleChar = tokens.filter((t) => t.replace(/[^a-zA-Z]/g, '').length <= 1);
		if (singleChar.length / tokens.length > 0.5) {
			return "That doesn't look like a real explanation. Please write a brief sentence.";
		}
	}

	if (Object.keys(counts).length < 3) {
		return "That doesn't look like a real explanation. Please write a brief sentence.";
	}

	const gibberishTokens = words.filter(isGibberishWord);
	if (gibberishTokens.length / words.length > MAX_GIBBERISH_RATIO) {
		return "That doesn't look like a real explanation. Please write a brief sentence.";
	}

	return null;
}
